// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__7nhaU","image":"Avatar_image__2NX+2"};